import { useState, useEffect, useCallback } from "react";
import { useAlgorithmStore } from "../../dashboard/store/useGennie";
import type { AlgorithmConfig } from "@/features/login/types";
import { algorithmService } from "../services/api";

interface UseAlgorithmConfigReturn {
  config: AlgorithmConfig | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useAlgorithmConfig = (
  taskId: string,
): UseAlgorithmConfigReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { configs, setConfig } = useAlgorithmStore();

  const fetch = useCallback(async () => {
    if (!taskId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await algorithmService.getTaskParameter(taskId);
      setConfig(taskId, result);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Failed to load config");
    } finally {
      setLoading(false);
    }
  }, [taskId, setConfig]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    config: configs[taskId] ?? null,
    loading,
    error,
    refetch: fetch,
  };
};
